export enum HonorificPrefixKf {
  Monsieur = 0,
  Madame = 1,
  Mademoiselle = 2,
}

export abstract class AbstractSmallCustomerDto {
  civility!: HonorificPrefixKf;
  lastName!: string;
  firstName!: string;
  birthdate?: Date;
  phoneNumber?: string;
  email!: string;
  houseNumber?: string;
  postalCode?: string;
  address?: string;
  buildingFloorStaircase?: string;
  localityPoBox?: string;
  city?: string;
  country?: string;
  companyName?: string;
}
